import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Notification } from '../../../modals/notification';

@Injectable({
  providedIn: 'root',
})
export class NotificationsListService {
  private _notifications: BehaviorSubject<any>;

  constructor() {
    this._notifications = <BehaviorSubject<any>>new BehaviorSubject(null);
  }

  get notificationsState(): Observable<Notification[]> {
    return this._notifications.asObservable();
  }

  updateNotifications(notifications: Notification[]): void {
    this._notifications.next(notifications);
  }
}
